<template>
  <div class="post-review">
    <v-row align="center">
      <v-col cols="12" :md="3">
        <Rating :count="reviewData.overall" :readonly="readonly" />
      </v-col>
      <v-col cols="12" :md="9">
        <v-row>
          <v-col cols="12" :md="6" class="py-0" v-if="reviewData.facilities">
            <ChartLine
              :rowAlign="true"
              :isShowValue="true"
              :name="$gettext('Facilities')"
              :value="reviewData.facilities"
            />
          </v-col>
          <v-col cols="12" :md="6" class="py-0" v-if="reviewData.clubhouse">
            <ChartLine
              :rowAlign="true"
              :isShowValue="true"
              :name="$gettext('Clubhouse')"
              :value="reviewData.clubhouse"
            />
          </v-col>
          <v-col cols="12" :md="6" class="py-0" v-if="reviewData.maintenance">
            <ChartLine
              :rowAlign="true"
              :isShowValue="true"
              :name="$gettext('Course maintenance')"
              :value="reviewData.maintenance"
            />
          </v-col>
          <v-col cols="12" :md="6" class="py-0" v-if="reviewData.value">
            <ChartLine
              :rowAlign="true"
              :isShowValue="true"
              :name="$gettext('Value for money')"
              :value="reviewData.value"
            />
          </v-col>
          <v-col cols="12" :md="6" class="py-0" v-if="reviewData.surroundings">
            <ChartLine
              :rowAlign="true"
              :isShowValue="true"
              :name="$gettext('Surroundings')"
              :value="reviewData.surroundings"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Rating from "@/components/Rating";
import ChartLine from "@/components/Courses/ChartLine";
export default {
  props: {
    readonly: { type: Boolean, default: false },
    reviewData: {
      default: () => {},
    },
  },
  components: { ChartLine, Rating },
};
</script>
